import { Injectable } from '@angular/core';
import * as Forge from 'node-forge';
import { publickey } from '../../RSA/public.key.pem';

// npm i crypto-js
// npm i --save-dev @types/crypto-js

@Injectable({
    providedIn: 'root'
})
export class EncryptDecryptService {

    encrypt(text: string): any {
        const rsa = Forge.pki.publicKeyFromPem(publickey);
        const encrypt = rsa.encrypt(text, 'RSA-OAEP');
        const hex = this.toHex(encrypt);
        //return hex;
        return hex;
    }

    toHex(string: string) {
        return string
            .split("")
            .map(c => c.charCodeAt(0).toString(16).padStart(2, "0"))
            .join("");
    }
}